import * as React from 'react';
import {View} from 'react-native';
import Screen from '../../shared/components/screen';
import {Props} from './model';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {Routes, Screens} from '../../shared/routing';

import {Privileges} from '../../assets/images';
import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {PrivilegeCard} from './components/privilegeCard';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {Text} from '../../shared/components/text';
import {Image} from '../../shared/components/image';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../redux/selectors/resources';
import {Markdown} from '../../shared/components/markdown';
import {CustomScrollView} from '../../shared/components/scrollView';
import {LoadableContent} from '../../shared/components/loadableContent';
import {ContentWithRightImage} from '../../shared/components/contentWithRightImage';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Мои льготы',
    routeName: Screens.PrivilegesService,
    webRoute: Routes.privilegesService,
  },
];

export default ({privileges}: Props) => {
  const deviceSize = useDeviceSize();
  const content = useSelector(contentSelector());
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContainer: {
      ...mediaOnly(DeviceSize.desktop, {marginTop: 32, paddingHorizontal: 24}, {marginTop: 20, paddingHorizontal: 16}),
      marginBottom: theme.screen.bottomOffset - (deviceSize === DeviceSize.desktop ? 40 : 20),
    },
    sectionTitle: {
      ...theme.fonts.h2,
      marginTop: 40,
      marginBottom: 30,
    },
    sectionSubTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h3,
          marginBottom: 40,
        },
        {
          ...theme.fonts.action,
          marginBottom: 28,
        },
      ),
    },
    noData: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, {...theme.fonts.bodySmallLight, textAlign: 'center'}),
      color: theme.privilegeNoData.color,
    },
    sectionTextWrapper: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginBottom: 71,
        },
        {
          marginBottom: 30,
        },
      ),
    },
    cards: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    cardWrapper: {
      ...mediaOnly(DeviceSize.desktop, {marginBottom: 40}, {marginBottom: 20}),
    },
    contentWithRightImageContentStyle: mediaOnly(DeviceSize.desktop, {width: 875, maxWidth: '80%', minHeight: 0}),
    contentWithRightImageBackgroundStyle: {width: 425, height: 466, right: -20},
    contentWithRightImageIconStyle: {
      paddingTop: 33,
      paddingRight: 32,
      color: theme.supportService.iconsColor.privileges,
    },
  }));

  const renderPrivileges = !privileges?.socialSupportMeasures?.length ? (
    <Text testID='your-priviliges-not-title-id' style={styles.noData}>
      Назначенных льгот нет
    </Text>
  ) : (
    privileges?.socialSupportMeasures?.map((item) => (
      <View style={styles.cardWrapper} key={item.id}>
        <PrivilegeCard privilege={item} />
      </View>
    ))
  );

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <Breadcrumbs style={{flex: undefined}} routes={routes} />
          <ContentWithRightImage
            contentStyle={styles.contentWithRightImageContentStyle}
            backgroundStyle={styles.contentWithRightImageBackgroundStyle}
            iconStyle={styles.contentWithRightImageIconStyle}
            icon={<Image source={Privileges as any} width={355} height={309} />}
            hideImage={deviceSize !== DeviceSize.desktop}>
            <ResponsiveView only={[DeviceSize.desktop]}>
              <Text testID='yoyr-privileges-title-id' style={styles.sectionTitle}>
                Мои льготы
              </Text>
            </ResponsiveView>
            <View style={styles.sectionTextWrapper}>
              <Markdown>{content.services.privilegesService.descriptionMarkdown}</Markdown>
            </View>
            <Text testID='your-priviliges-list-title-id' style={styles.sectionSubTitle}>
              Ваши меры социальной поддержки:
            </Text>
          </ContentWithRightImage>
          <LoadableContent loading={!privileges}>
            <View style={styles.cards}>{renderPrivileges}</View>
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
